module.exports = __webpack_public_path__ + "img/Muse LogoMark Green.3b70e31e.svg";